/* @flow */

export function requestActivity({ id }: Object) {
  return {
    type: 'REQUEST_ACTIVITY',
    payload: {
      id
    }
  };
}